import React, { useRef, useCallback, useEffect } from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { useState } from 'react'

const severityMap = {
  success: 'success',
  error: 'error',
  warn: 'warning',
  warning: 'warning',
  info: 'info'
}

export const Growl = () => {
  const [messages, setMessages] = useState([])

  const show = useCallback((msg) => {
    const id = Date.now() + Math.random()
    setMessages(prev => [...prev, { ...msg, id }])
  }, [])

  useEffect(() => {
    window.growl = { show }
  }, [show])

  const handleClose = (id) => {
    setMessages(prev => prev.filter(m => m.id !== id))
  }

  return (
    <>
      {messages.map((msg, index) => (
        <Snackbar
          key={msg.id}
          open
          autoHideDuration={4000}
          onClose={() => handleClose(msg.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          sx={{ marginTop: `${50 + index * 70}px` }}
        >
          <Alert
            onClose={() => handleClose(msg.id)}
            severity={severityMap[msg.severity] || 'info'}
            variant='filled'
            sx={{ width: '100%' }}
          >
            {msg.summary && <strong>{msg.summary}: </strong>}
            {msg.detail}
          </Alert>
        </Snackbar>
      ))}
    </>
  )
}
